export default __webpack_public_path__ + "static/media/fontawesome-webfont3e6e.1e59d233.ttf";